import { render, staticRenderFns } from "./WorkBench.vue?vue&type=template&id=6cb48f08&scoped=true"
import script from "./WorkBench.vue?vue&type=script&lang=js"
export * from "./WorkBench.vue?vue&type=script&lang=js"
import style0 from "./WorkBench.vue?vue&type=style&index=0&id=6cb48f08&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cb48f08",
  null
  
)

export default component.exports